import { ArrowsOut, Minus, Plus } from '@phosphor-icons/react';
import { Divider, IconButton, Tooltip } from '@reelplicate/ui';
import { Panel, useReactFlow, useStore } from '@xyflow/react';

/**
 * Figma Zoom Controls (69:142): −, level, +, fit to screen, on a bg/surface
 * radius/md card with border/subtle and Shadow/SM, 16px from the canvas's
 * bottom-left corner.
 */
export function ZoomControls() {
  const { zoomIn, zoomOut, fitView } = useReactFlow();
  const zoom = useStore((state) => state.transform[2]);
  return (
    <Panel position="bottom-left" className="!m-4">
      <div className="bg-bg-surface border-border-subtle flex items-center gap-0.5 rounded-md border p-1 shadow-sm">
        <Tooltip content="Zoom out">
          <IconButton
            icon={Minus}
            size="sm"
            aria-label="Zoom out"
            onClick={() => void zoomOut()}
          />
        </Tooltip>
        <span
          aria-live="polite"
          className="text-data-md text-text-primary w-12 text-center"
        >
          {Math.round(zoom * 100)}%
        </span>
        <Tooltip content="Zoom in">
          <IconButton
            icon={Plus}
            size="sm"
            aria-label="Zoom in"
            onClick={() => void zoomIn()}
          />
        </Tooltip>
        <Divider orientation="vertical" className="mx-0.5 h-5" />
        <Tooltip content="Fit to screen">
          <IconButton
            icon={ArrowsOut}
            size="sm"
            aria-label="Fit to screen"
            onClick={() => void fitView({ padding: 0.2 })}
          />
        </Tooltip>
      </div>
    </Panel>
  );
}
